// Generated by genversion.
export const version = '8.0.5';
//# sourceMappingURL=version.js.map